export { MPVCarIcon } from './car-shape-mpv'
